if (!customElements.get('quick-comparison-table')) {
  customElements.define(
    'quick-comparison-table',
    class QuickComparisonTable extends HTMLElement {
      constructor() {
        super();

        // Optional: trigger event for animations
        setTimeout(() => {
          this.dispatchEvent(new CustomEvent('quick-comparison-table:loaded'));
        }, 100);
      }
    }
  );
}